/**
 * created by wang lei
 格式刷页面
 *
 */
import React, {Component} from 'react';
import formatBrush from './formatBrush.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";
import {toolWidth} from "../../twoLinesEditorToolsSpace";

export default class FormatBrushTool extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            formatmatch:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let formatmatch = this.props.editor.queryCommandState("formatmatch");
        this.setState({formatmatch: formatmatch === 1});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let formatmatch = this.props.editor.queryCommandState("formatmatch");
        this.setState({formatmatch: formatmatch === 1});
    }

    render() {
        let style = {};
        if(this.state.formatmatch){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'formatmatch' );
                this.props.editor.selection.clearRange();
                this.props.editor.focus();
            }}>
                <img className={"editor-format-match-tool-btn"} style={style} width={toolWidth - 2} src={formatBrush}/>
                <style>{`
                    .editor-format-match-tool-btn{
                        border: 1px solid #f2f6fc
                    }
                    .editor-format-match-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-format-match-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style>
            </span>
        )
    }

}